import React from 'react';

const TextLogo = ({ size = 'large' }) => {
  // Size variants
  const sizeClasses = {
    small: 'text-2xl',
    medium: 'text-4xl md:text-5xl',
    large: 'text-7xl md:text-8xl lg:text-9xl',
    xlarge: 'text-8xl md:text-9xl lg:text-[10rem]'
  };

  return (
    <div 
      className={`inline-block ${sizeClasses[size]}`} 
      style={{ direction: 'ltr', unicodeBidi: 'bidi-override' }}
    >
      <span 
        style={{ fontFamily: 'Roboto-Medium, Roboto, sans-serif', fontWeight: 500 }}
        className="text-white tracking-tight"
      >
        SYR
      </span>
      <span 
        style={{ fontFamily: 'Roboto-Thin, Roboto, sans-serif', fontWeight: 100 }}
        className="text-white tracking-tight"
      >
        VERSE
      </span>
    </div>
  );
};

export default TextLogo;
